import type { TOC } from '@ember/component/template-only'
import { and } from 'ember-truth-helpers'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { PageHeaderReturnLink } from 'teacher-ui-client/components/page-header/return-link'
import { PageHeaderBackButton } from 'teacher-ui-client/components/page-header/back-button'

interface Signature {
  Args: {
    title: string
    returnLinkText?: string
    returnLinkRoute?: string
    showBack?: boolean
  }
}

export const ReportingTeacherUiHeader: TOC<Signature> = <template>
  <PageHeader data-test-reporting-teacher-ui-header>
    <:title>
      <h1>
        {{@title}}
      </h1>
    </:title>
    <:left>
      {{#if (and @returnLinkText @returnLinkRoute)}}
        <PageHeaderReturnLink @route={{@returnLinkRoute}}>
          {{@returnLinkText}}
        </PageHeaderReturnLink>
      {{else if @showBack}}
        <PageHeaderBackButton />
      {{/if}}
    </:left>
  </PageHeader>
</template>

export default ReportingTeacherUiHeader
